// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> conrad-at-concord-mills
// Generated: 2026-11-03T20:36:58.087Z
// Counts: 2 design, 82 content, 37 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Conrad at Concord Mills, we believe everyone deserves an effortless welcome—online and in person. We're committed to keeping our website accessible and easy to navigate for every visitor, so exploring your next home always feels comfortable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From the resort-style pool and 24-hour fitness center to the Wi-Fi business lounge, Starbucks coffee bar, and grilling pavilion, Conrad at Concord Mills is built for the way you actually live. Scroll down to explore every community and in-home amenity—including the fenced dog park with pet spa, EV charging, and polished apartment finishes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>You're just a few steps from calling Conrad at Concord Mills home—where resort-inspired amenities, upgraded finishes, and a location near Concord Mills and the University City corridor come together. Apply online today and make polished, connected apartment living your everyday.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>We'd love to hear from you.</strong> Reach out to the Conrad at Concord Mills leasing team with any questions about our resort-style community, upgraded one-, two-, and three-bedroom apartments, or scheduling a tour. Whether you need directions off I-85 and I-485 or details on availability, we're here to make your next move easy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>We love this corner of Concord, and we're sure you will too. Explore our handpicked list of nearby favorites—from race-day thrills and family aquariums to green trails and standout shopping—and start finding your new go-to spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Conrad at Concord Mills' one-, two-, and three-bedroom apartments, ranging from a cozy 740-square-foot layout to a spacious 1,430-square-foot home. Each floor plan pairs upgraded finishes—granite countertops, designer cabinetry, and wood-style flooring—with the room you need to live comfortably.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Scroll through Conrad at Concord Mills and see the details up close, from granite kitchens with subway tile and wood-style flooring to bright, open living spaces in our one-, two-, and three-bedroom homes. The gallery also captures the resort-inspired pool, 24-hour fitness center, Wi-Fi business lounge, Starbucks coffee bar, and grilling pavilion, so you can picture life here before you visit in Charlotte.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>The excitement of Concord, right outside your door.</strong> From the roar of race weekends at Charlotte Motor Speedway to shark tunnels at SEA LIFE, outlet shopping at Concord Mills, and quiet mornings along Clarks Creek Greenway, Conrad at Concord Mills puts the area's best within an easy drive. With I-85, I-485, and the UNC Charlotte LYNX Blue Line all close by, your week stays connected and your weekends stay open.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Bring the whole family—including the four-legged members.</strong> Cats and dogs feel right at home at Conrad at Concord Mills, where spacious layouts, a fenced Bark Park, and an on-site pet spa make everyday care and playtime a breeze. Just outside, the Mallard Creek area keeps pet supplies, greenway walks, and outdoor adventures close at hand.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Conrad at Concord Mills, protecting your personal information is part of the same care we bring to resort-style living. Learn how we collect, use, and safeguard the details you share with our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f237e-ef90-70a7-ad3d-9ea5089fdc34.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Everything you need, right at your fingertips.</strong><br>Sign in to your Conrad at Concord Mills resident portal to pay rent online, submit maintenance requests, and stay in the loop on community updates. It's 24/7 convenience that lets you get back to resort-style comfort and connected, everyday living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Hear straight from the residents who call Conrad at Concord Mills home.</strong> Below you'll find real feedback praising the welcoming leasing team, same-day maintenance, modern apartment finishes, and pet-friendly perks like the dog park and wash station—all just minutes from Concord Mills shopping and dining.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Ready to see Conrad at Concord Mills for yourself?</strong> Schedule an in-person or virtual tour to walk the polished, upgraded homes and experience the resort-inspired amenities firsthand. Pick a time that works for you, and we'll show you why this Concord Mills community feels like an easy place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore everything Conrad at Concord Mills has to offer—from floor plans and amenities to our resort-style community and Concord Mills neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you for reaching out—we've received your inquiry.</strong> The Conrad at Concord Mills team will follow up with you soon, so you can start picturing resort-style comfort, polished apartment finishes, and an easy, connected life in the Concord Mills corridor.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Explore Conrad at Concord Mills without leaving home.</strong> Step through a two-bedroom apartment in 3D, then tour the fitness center, pool, and amenities center to see how resort-style living comes together—all at your own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced-in dog park with agility equipment and a bench."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-1b59-71ab-b16b-235326c2ac26.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Bark Park & Pet Spa"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a blue retro refrigerator, coffee maker, sink, and modern decor."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-062b-746b-a9e5-e1e615ef1375.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Coffee Bar"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Electric vehicle charging stations in the parking lot."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e826-72cb-88ca-3f7fbc63a324.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "EV Charging Stations"
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resident lounge with teal sofas, decorative lighting, and large windows"
      },
      "title": {
        "type": "VALUE",
        "customValue": "American Landmark 360"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5762658426945536/019d02f4-aa17-70a2-bcbf-7b77d7d9b82e.webp"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Designer cabinetry with granite countertops and black appliances"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Designer Cabinetry"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0fec-71ad-82ce-1922af6b2c85.webp"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Electric vehicle charging stations in the resident parking lot"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Car Charging Stations"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e826-72cb-88ca-3f7fbc63a324.webp"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Swimming Pool"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Our resort-inspired swimming pool is the centerpiece of life at Conrad at Concord Mills, framed by a spacious sundeck, a relaxing hot tub, and plenty of shaded lounge seating. It's where residents cool off on warm Charlotte afternoons, soak up the sun, and unwind with neighbors—an easy retreat just steps from your door.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5762658426945536/019d02f4-714e-704f-933a-e0e03883af84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, black appliances, and subway tile backsplash."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b36f-74de-be82-546f6ab05f89.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Charlotte Motor Speedway"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Charlotte Motor Speedway"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.charlottemotorspeedway.com/"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-19da-70ba-831a-66291fdc9f77.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "SEA LIFE Charlotte-Concord"
      },
      "title": {
        "type": "VALUE",
        "customValue": "SEA LIFE Charlotte-Concord"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.visitsealife.com/charlotte-concord/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-1085-70d9-8010-465933c04d62.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Concord Mills"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Concord Mills"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.simon.com/mall/concord-mills"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-ff4a-7165-98ed-1950c0b85838.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, elliptical, rowing machine, and weight machine. Pool visible through window."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e75d-70dc-8474-8a27ba02ca0b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a large sectional sofa, coffee table, and TV stand."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e80b-71fd-8aee-bf36aee01818.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a multi-story apartment building with blue siding and brick accents."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0de9-73c1-b99b-b046fba642a4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area in an apartment with modern furniture."
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5762658426945536/019d491d-8335-738b-a0ce-85cf47878306.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright, open-concept model living room and kitchen at Conrad at Concord Mills, with a sofa, coffee table, dining set, and a kitchen island."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0592-77ac-a6ca-8e156c49a541.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with balconies and staircases, surrounded by trees and green lawns."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5762658426945536/019d02f4-8bc3-7273-a946-354ee6c2289d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment buildings with balconies and staircases, surrounded by green grass and trees."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0de9-73c1-b99b-b046fba642a4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area in an apartment with modern furniture."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0592-77ac-a6ca-8e156c49a541.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with balconies and staircases, surrounded by trees and green lawns."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0592-77ac-a6ca-8e156c49a541.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with balconies and staircases, surrounded by trees and green lawns."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://conrad.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Exterior view of Conrad at Concord Mills apartment buildings with balconies and green lawns."
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0de9-73c1-b99b-b046fba642a4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area in an apartment with modern furniture."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://conrad.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Open-concept apartment living room connected to a modern kitchen and dining space."
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
